'use client';
import { Moon, Sun } from 'lucide-react';
import { Button } from '../components/ui/button.jsx';
import { useTheme } from './theme-provider.jsx';
export function ThemeToggle() {
    var _a = useTheme(), theme = _a.theme, setTheme = _a.setTheme;
    return (<Button variant="ghost" size="icon" onClick={function () { return setTheme(theme === 'light' ? 'dark' : 'light'); }}>
      <Moon className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90"/>
      <Sun className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0"/>
      <span className="sr-only">Toggle theme</span>
    </Button>);
}
